import { Component, OnDestroy, ViewChild, EventEmitter } from "@angular/core";
import { cloneDeep } from "lodash";
import { Subscription } from "rxjs";
import { CclMessageService, CclNavbarSecondaryService } from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";

@Component({
    selector: "setting",
    templateUrl: "./setting.view.html",
    providers: []
})
export class SettingView implements OnDestroy {
    subscription: Subscription;
    buttonConfig: any = {};

    constructor(
        private sharedService: SharedService,
        private messageService: CclMessageService,
        private navSecondaryService: CclNavbarSecondaryService,
        ) {
        this.navSecondaryService.sectionLabel = "Additional Settings";
        this.subscription = this.messageService.getMessage().subscribe(message => this.updateData(message));
        this.loadData();
    }

    updateData(message) {
        if (message.text == "update-setting") {
            this.loadData();
        }
    }

    loadData() {
        if (this.sharedService.sessionLayoutConfig.general?.catalogConfig.buttonConfig) {
            const sessionConfigObj = this.sharedService.configs[this.sharedService.configTypes.SESSION['general']];

            if (sessionConfigObj == null || sessionConfigObj.id == null) {
                this.buttonConfig = this.sharedService.sessionLayoutConfig.general.catalogConfig.buttonConfig;
            } else {
                const sessionConfig = JSON.parse(sessionConfigObj.config);
                this.buttonConfig = sessionConfig.catalogConfig.buttonConfig;
            }
        }
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }
}
